<script setup lang="ts">

interface Props {
  buttonText: string;
  type: 'ok' | 'cancel';
  ionIcon?: string;
  routerLink?: string;
  loading?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  ionIcon: '',
  routerLink: '',
  loading: false,
  disabled: false
});

const fill = computed(() => {
  switch (props.type) {
    case 'ok':
      return 'solid';
    case 'cancel':
      return 'outline';
    default:
      return 'outline';
  }
});
</script>

<template>
  <IonButton
    shape="round"
    expand="block"
    :fill="fill"
    :router-link="routerLink"
    :disabled="loading || disabled"
  >
    <IonIcon
      v-if="ionIcon"
      slot="start"
      :class="ionIcon"
    />
    <IonSpinner
      v-if="loading"
      :color="fill === 'solid' ? 'white' : 'primary'"
    />
    <span v-else>{{ buttonText }}</span>
  </IonButton>
</template>

<style scoped>
ion-button {
    margin: 1rem;
    height: 2.5rem;
}

</style>
